import "./styles/user.less";
import React from "react";
import { connect } from "dva";
import $$ from "cmn-utils";
import http from "@/http";
import SelectUnit from "../routes/select-unit";
import SetHtmlFontSize from "./SetHtmlFontSize";
import { LoginUnit } from "@/utils/login-unit";

const HttpSso = http.tokiot.sso;

@connect(({ global }) => ({ user: global.user }))
export default class UserLayout extends React.PureComponent {
  state = {
    selectUnitVisibal: false,
  };
  componentDidMount() {
    const { location } = this.props;
    if (location.pathname === `/sso`) {
      let query = location.search.substring(1);
      let param = new URLSearchParams(query);
      let clientId = param.get(`clientId`);
      let clientSecret = param.get(`clientSecret`);
      let ticket = param.get(`ticket`);
      if (!clientId) clientId = ``;
      if (!clientSecret) clientSecret = ``;
      if (!ticket) ticket = ``;
      if (clientId.length > 0 && clientSecret.length > 0 && ticket.length > 0) {
        this.loginSSC({
          clientId,
          clientSecret,
          ticket,
        });
      } else {
        if (!this.userChange()) {
          this.props.dispatch({ type: "global/getUserInfo" });
        }
      }
    } else {
      let query = window.location.search.substring(1);
      let param = new URLSearchParams(query);
      let ticket = param.get(`ticket`);
      if (!ticket) ticket = ``;
      if (ticket.length > 0) {
        this.login(ticket);
      } else {
        if (!this.userChange()) {
          this.props.dispatch({ type: "global/getUserInfo" });
        }
      }
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    let prevUser = prevProps.user;
    let user = this.props.user;
    let prevUserId =
      prevUser && prevUser.userInfo && prevUser.userInfo.id
        ? prevUser.userInfo.id
        : undefined;
    let userId =
      user && user.userInfo && user.userInfo.id ? user.userInfo.id : undefined;
    if (prevUserId != userId) {
      this.userChange();
    }
  }

  login = (ticket) => {
    const { history } = this.props;
    HttpSso.shishi({ ticket }).then((ret) => {
      if (ret && ret.token_type && ret.access_token) {
        $$.setStore("headers", {
          Authorization: ret.token_type + " " + ret.access_token,
        });
        $$.setStore("accessToken", ret.access_token);
        this.props.dispatch({ type: "global/getUserInfo" });
      } else {
        LoginUnit.Logout();
      }
    });
  };

  loginSSC = (param) => {
    const { history } = this.props;
    HttpSso.token(param).then((ret) => {
      if (ret && ret.token_type && ret.access_token) {
        $$.setStore("headers", {
          Authorization: ret.token_type + " " + ret.access_token,
        });
        $$.setStore("accessToken", ret.access_token);
        this.props.dispatch({ type: "global/getUserInfo" });
      } else {
        LoginUnit.Logout();
      }
    });
  };
  userChange = () => {
    const { user } = this.props;
    let userId =
      user && user.userInfo && user.userInfo.id ? user.userInfo.id : undefined;
    let unitId = user && user.unit && user.unit.id ? user.unit.id : undefined;
    if (userId && userId.length > 0) {
      let unit = user.unit;
      let role = user.role;

      if (role) {
        if (role.code === `ORGAN`) {
          // this.setState({ selectUnitVisibal: true });
          window.location.href = `${window.location.origin}/#/navigation/index`;
        } else if (role.code === `UNIT` || role.code === `UNIT_ADMIN`) {
          if (unit.type !== "Organs") {
            window.location.href = `${window.location.origin}/enterprise/${unitId}/home`;
          } else {
            this.setState({ selectUnitVisibal: true });
          }
        } else {
          window.location.href = `${window.location.origin}/#/navigation/index`;
        }
      } else {
        //非机构管理员直接跳转到主界面
        window.location.href = `${window.location.origin}/#/home`;
      }
      return true;
    } else {
      return false;
    }
  };
  render() {
    const { selectUnitVisibal } = this.state;
    if (selectUnitVisibal) {
      SetHtmlFontSize();
      return <SelectUnit />;
    } else {
      return ``;
    }
  }
}
